import React, {useContext} from 'react'
import {AccordionContext, useAccordionToggle, Accordion, Card} from "react-bootstrap";
import styled from 'styled-components'


const InitiativeWrapper = styled.div`
    background: #CB1700;
    padding: 50px 25%;
    @media only screen and (max-width: 600px) {
        padding: 50px 2%;
    }
    
    h2{
      color: white;
      font-weight: bold;
      font-size: 1.5rem;
      text-align: center;
    
    }
    h3{
      color: #CB1700;
      font-weight: bold;
      font-size: 1.25rem;
      padding: 0;
      margin: 0;
    }
    h5{
    font-weight: bold;
    }
    .card{
        margin: 20px 0;
        border-radius: 20px;
        border-top-left-radius: 20px !important;
        border-top-right-radius: 20px !important;
        border-bottom-right-radius: 20px !important;
        border-bottom-left-radius: 20px !important;
    }
`

const ContextAwareWrapper = styled.div`
    display: flex;
    align-items: center;
    h3{
      width: 100%;
    }
    .title{
      transition: 0.3s ease-out;
    }
    .active{
      transform: rotate(45deg);
    }
    
`

const Initiative = () => (
    <InitiativeWrapper>
        <Example />
    </InitiativeWrapper>

)


const Cross = (props) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g >
            <rect x="12" width="6" height="30" fill="#CB1700"/>
            <rect y="18" width="6" height="30" transform="rotate(-90 0 18)" fill="#CB1700"/>
        </g>

    </svg>

)

function ContextAwareToggle({ title, children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <ContextAwareWrapper
            type="button"
            onClick={decoratedOnClick}
        >
            <h3>{title}</h3>
            <Cross className={isCurrentEventKey ? 'title active' : 'title'}  />
        </ContextAwareWrapper>
    );
}

const Wrapper = styled.div`
    
`

function Example() {
    return (
        <Wrapper>
            <h2>Присоединившиеся инициативы: </h2>
            <Accordion>
                <Card>
                    <Card.Header>
                        <ContextAwareToggle title={'УЛЬТИМАТУМ ДИАСПОР БЕЛАРУСОВ'} eventKey="0">Click me!</ContextAwareToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <p>Светлана Тихановская объявила Народный Ультиматум властям Беларуси, срок которого истекает 25-го октября.
                            </p>
                            <p>Сообщество «Беларусы Зарубежья» также вносит свой вклад в строительство Новой Демократической Беларуси. За пределами страны на данный момент проживает приблизительно 1,5 миллионов беларусов, что составляет около 15% населения страны.
                            </p>
                            <h5>Мы, представители сообщества «Беларусы Зарубежья», выражаем солидарность с народом Беларуси и требуем:
                            </h5>
                            <h5>1. Незамедлительного ухода Александра Лукашенко</h5>
                            <h5>2. Освобождения всех политических заключенных</h5>
                            <h5>3. Проведения новых честных выборов</h5>

                            <p>
                                «Беларусы Зарубежья» будут пристально следить за ситуацией во время национальной забастовки и реагировать на противоправные действия руководителей предприятий и организаций, чиновников, судей и иных лиц, причастных к нарушению прав человека и репрессиям, рассматривая возможность введения персональных санкций против каждого из них.
                            </p>
                            <h4>В случае невыполнения требований, «Беларусы Зарубежья» предпримут следующие действия:
                            </h4>
                            <ul>
                                <li>
                                    Рассмотрение возможности введения персональных санкций против лиц, причастных к нарушению прав человека и репрессиям.
                                </li>
                                <li>Лоббирование и инициирование механизмов международного правосудия</li>
                                <li>Признание Светланы Тихановской лидером Беларуси, а Координационный Совет – представительным органом беларусов, в том числе «Беларусов Зарубежья»</li>
                            </ul>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Card.Header>
                        <ContextAwareToggle title={'МЕДИЦИНСКОЕ СООБЩЕСТВО'} eventKey="1" />
                    </Card.Header>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            <iframe width="100%" height="315" src="https://www.youtube.com/embed/dPsuWMZiJvQ"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                            <h5>
                                Медицинское сообщество Республики Беларусь поддерживает Народный Ультиматум и национальную забастовку, в случае невыполнения требований.
                            </h5>
                            <p>
                                В числе подписавших <a href={"https://clck.ru/RYsyv"}>открытое письмо</a>: Мрочек Александр Геннадьевич, Савченко Александр Николаевич, Соловей Никита Владимирович, Минич Александр Анатольевич, Мартов Владимир Юрьевич, Доронина Инесса Григорьевна, Колядич Геннадий Иванович
                            </p>
                            <p>
                                Присоединиться: <a href={"https://clck.ru/RYsyv"}>https://clck.ru/RYsyv</a>
                            </p>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card><
                Card>
                    <Card.Header>
                        <ContextAwareToggle title={'ДЗЕЯЧЫ КУЛЬТУРЫ'} eventKey="2" />
                    </Card.Header>
                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            <iframe width="100%" height="315" src="https://www.youtube.com/embed/sbgHK4uazCQ"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </Wrapper>

    );
}

export default Initiative;
